import { matchPath } from 'react-router-dom';
import { useLocation } from '@namespace/i18n';

/**
 * Return match for the first matched path in the list or null if nothing matched.
 */
export const useMatchPaths = (paths = [], options) => {
  const { pathname } = useLocation();

  return paths.find((path) =>
    matchPath(options != null ? { path, ...options } : path, pathname)
  );
};
